module.exports = __webpack_public_path__ + "img/review-1.848813e7.jpg";